import { IconBase } from "./iconBase.js";
import { Fragment, jsx, jsxs } from "@emotion/react/jsx-runtime";
//#region src/button.tsx
var Button = ({ type, ...rest }) => /* @__PURE__ */ jsx(IconBase, {
	viewBox: "0 0 24 24",
	...rest,
	children: type === "stroke" ? /* @__PURE__ */ jsxs(Fragment, { children: [
		/* @__PURE__ */ jsx("path", {
			d: "M2 6.75H22C22.6904 6.75 23.25 7.30964 23.25 8V16C23.25 16.6904 22.6904 17.25 22 17.25H2C1.30964 17.25 0.75 16.6904 0.75 16V8C0.75 7.30964 1.30964 6.75 2 6.75Z",
			stroke: "currentColor",
			strokeWidth: "1.5"
		}),
		/* @__PURE__ */ jsx("path", {
			d: "M9.21704 15C7.56385 15 6.5 13.7936 6.5 11.996C6.5 10.1984 7.56385 9 9.21704 9C10.8702 9 11.9341 10.1984 11.9341 11.996C11.9341 13.7936 10.8702 15 9.21704 15ZM9.21704 14.0892C10.0819 14.0892 10.8013 13.3542 10.8013 11.996C10.8013 10.6378 10.0819 9.91079 9.21704 9.91079C8.35218 9.91079 7.63274 10.6378 7.63274 11.996C7.63274 13.3542 8.35218 14.0892 9.21704 14.0892Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ jsx("path", {
			d: "M13.8033 11.7563L16.0688 9.10386H17.3469L15.3034 11.4368L17.5 14.8961H16.2065L14.5687 12.2836L13.8033 13.1545V14.8961H12.7088V9.10386H13.8033V11.7563Z",
			fill: "currentColor"
		})
	] }) : /* @__PURE__ */ jsxs(Fragment, { children: [
		/* @__PURE__ */ jsx("path", {
			d: "M2 6.75H22C22.6904 6.75 23.25 7.30964 23.25 8V16C23.25 16.6904 22.6904 17.25 22 17.25H2C1.30964 17.25 0.75 16.6904 0.75 16V8C0.75 7.30964 1.30964 6.75 2 6.75Z",
			fill: "currentColor",
			stroke: "currentColor",
			strokeWidth: "1.5"
		}),
		/* @__PURE__ */ jsx("path", {
			d: "M9.21704 15C7.56385 15 6.5 13.7936 6.5 11.996C6.5 10.1984 7.56385 9 9.21704 9C10.8702 9 11.9341 10.1984 11.9341 11.996C11.9341 13.7936 10.8702 15 9.21704 15ZM9.21704 14.0892C10.0819 14.0892 10.8013 13.3542 10.8013 11.996C10.8013 10.6378 10.0819 9.91079 9.21704 9.91079C8.35218 9.91079 7.63274 10.6378 7.63274 11.996C7.63274 13.3542 8.35218 14.0892 9.21704 14.0892Z",
			fill: "white"
		}),
		/* @__PURE__ */ jsx("path", {
			d: "M13.8033 11.7563L16.0688 9.10386H17.3469L15.3034 11.4368L17.5 14.8961H16.2065L14.5687 12.2836L13.8033 13.1545V14.8961H12.7088V9.10386H13.8033V11.7563Z",
			fill: "white"
		})
	] })
});
//#endregion
export { Button };
